export const more_horizontal = () => (
  <path
    d="M12 13a1 1 0 100-2 1 1 0 000 2zM19 13a1 1 0 100-2 1 1 0 000 2zM5 13a1 1 0 100-2 1 1 0 000 2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
